import { FC } from "react";
import Box, { BoxProps } from "@mui/material/Box";
import ArrowRightUpIcon from "./ArrowRightUpIcon";
import ArrowRightIcon from "./ArrowRightIcon";

interface ArrowHoverIconProps extends BoxProps {
  hovered: boolean;
  setHovered: (hovered: boolean) => void;
}

const ArrowHoverIcon: FC<ArrowHoverIconProps> = ({ hovered, sx, ...props }) => {
  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        lineHeight: 0,
        cursor: "pointer",
        ...sx,
      }}
      {...props}
    >
      {!hovered ? <ArrowRightUpIcon /> : <ArrowRightIcon />}
    </Box>
  );
};

export default ArrowHoverIcon;
